import React, { useState, useEffect } from "react";
import api from "../services/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

const COLORS = ["#1B3A8C","#F5A800","#28a745","#dc3545","#6c757d"];

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/rapports/stats").then(r => setStats(r.data)).catch(() => {}); }, []);

  const card = (title, value, icon, color) => (
    <div style={{ background: "#fff", borderRadius: 12, padding: 24, flex: 1, minWidth: 180,
      boxShadow: "0 2px 12px rgba(0,0,0,0.08)", borderLeft: `4px solid ${color}` }}>
      <div style={{ fontSize: 32, marginBottom: 8 }}>{icon}</div>
      <div style={{ fontSize: 28, fontWeight: 800, color }}>{value ?? "..."}</div>
      <div style={{ fontSize: 13, color: "#666", marginTop: 4 }}>{title}</div>
    </div>
  );

  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: "#1B3A8C", marginBottom: 8 }}>Tableau de bord</h1>
      <p style={{ color: "#888", marginBottom: 32 }}>Vue d'ensemble du recensement des supports OGP</p>
      <div style={{ display: "flex", gap: 20, marginBottom: 32, flexWrap: "wrap" }}>
        {card("Total Supports", stats?.totalSupports, "📦", "#1B3A8C")}
        {card("Soumissions", stats?.totalSoumissions, "📋", "#F5A800")}
        {card("Catégories", stats?.parCategorie?.length, "🏷️", "#28a745")}
        {card("Actifs", stats?.parStatut?.find(s=>s.statut==="actif")?.count ?? 0, "✅", "#17a2b8")}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
        <div style={{ background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
          <h3 style={{ color: "#1B3A8C", marginBottom: 16 }}>Supports par statut</h3>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={stats?.parStatut || []}>
              <XAxis dataKey="statut" /><YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#1B3A8C" radius={[4,4,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div style={{ background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
          <h3 style={{ color: "#1B3A8C", marginBottom: 16 }}>Par catégorie</h3>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie data={stats?.parCategorie || []} dataKey="count" nameKey="Categorie.nom" cx="50%" cy="50%" outerRadius={80} label>
                {(stats?.parCategorie || []).map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
